var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"title":"Product Options Sync","id":"product-sync-modal","okTitle":"Sync Products Options","ok-disabled":_vm.loading},on:{"ok":_vm.syncProducts}},[_c('p',[_vm._v(" Use this option if your current products available options doesn't match with the available options configured in this menu ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }